<template>
  <div id="modalCreateEditSurveyForm" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Pergunta</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3 mb-2">
              <div class="col-12 col-md-6">
                <label class="form-label">
                  Tipo de Pergunta: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  v-model="selectedComponent"
                  :disabled="surveyFormId"
                >
                  <option value="" selected disabled>
                    Selecione um componente de pergunta
                  </option>
                  <option
                    v-for="component in formComponents"
                    :key="component.id"
                    :value="component"
                  >
                    {{ component.name }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">
                  Ordem da Pergunta: <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  class="form-control"
                  min="1"
                  placeholder="Informe a ordem da pergunta"
                  v-model="surveyForm.order"
                />
              </div>
              <div
                v-if="selectedComponent && selectedComponent.freeField1"
                class="col-12"
              >
                <label class="form-label">
                  {{ selectedComponent.freeField1 }}:
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="surveyForm.field1"
                />
              </div>
              <div
                v-if="selectedComponent && selectedComponent.freeField2"
                class="col-12"
              >
                <label class="form-label">
                  {{ selectedComponent.freeField2 }}:
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="surveyForm.field2"
                />
              </div>
              <div
                v-if="selectedComponent && selectedComponent.freeField3"
                class="col-12"
              >
                <label class="form-label">
                  {{ selectedComponent.freeField3 }}
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="surveyForm.field3"
                />
              </div>
            </div>
            <div v-if="selectedComponent" class="mt-3">
              <h4 class="text-center">Pré-Visualização</h4>
              <OpenAnswerTextArea
                v-if="selectedComponent.componentVue === 'OpenAnswerTextArea'"
                :order="surveyForm.order"
                :freeField1="surveyForm.field1"
                :freeField2="surveyForm.field2"
                :freeField3="surveyForm.field3"
              />
              <ZeroToTenScale
                v-if="selectedComponent.componentVue === 'ZeroToTenScale'"
                :order="surveyForm.order"
                :freeField1="surveyForm.field1"
                :freeField2="surveyForm.field2"
                :freeField3="surveyForm.field3"
              />
              <LikertIconsScale
                v-if="selectedComponent.componentVue === 'LikertIconsScale'"
                :order="surveyForm.order"
                :freeField1="surveyForm.field1"
                :freeField2="surveyForm.field2"
                :freeField3="surveyForm.field3"
              />
              <StarIconsScale
                v-if="selectedComponent.componentVue === 'StarIconsScale'"
                :order="surveyForm.order"
                :freeField1="surveyForm.field1"
                :freeField2="surveyForm.field2"
                :freeField3="surveyForm.field3"
              />
              <SatisfactionScale
                v-if="selectedComponent.componentVue === 'SatisfactionScale'"
                :order="surveyForm.order"
                :freeField1="surveyForm.field1"
                :freeField2="surveyForm.field2"
                :freeField3="surveyForm.field3"
              />
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import OpenAnswerTextArea from '@/components/params/forms/OpenAnswerTextArea.vue'
import ZeroToTenScale from '@/components/params/forms/ZeroToTenScale.vue'
import LikertIconsScale from '@/components/params/forms/LikertIconsScale.vue'
import SatisfactionScale from '@/components/params/forms/SatisfactionScale.vue'
import StarIconsScale from '@/components/params/forms/StarIconsScale.vue'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditSurveyFormModal',

  props: {
    surveyId: {
      type: String,
      required: true,
    },
    nextOrder: {
      type: [String, Number],
      required: true,
    },
    surveyFormId: {
      type: String,
      default: null,
    },
  },

  components: {
    OpenAnswerTextArea,
    ZeroToTenScale,
    LikertIconsScale,
    SatisfactionScale,
    StarIconsScale,
  },

  data() {
    return {
      formComponents: [],
      selectedComponent: '',
      surveyForm: {
        surveyId: this.surveyId,
        formComponentId: null,
        order: this.nextOrder,
        field1: '',
        field2: '',
        field3: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.surveyFormId ? 'Atualizar' : 'Cadastrar'
    },
  },

  watch: {
    selectedComponent: {
      handler(newVal, oldVal) {
        if (!this.surveyFormId) {
          this.surveyForm.field1 = ''
          this.surveyForm.field2 = ''
          this.surveyForm.field3 = ''
        }
      },
    },
  },

  methods: {
    async getFormComponents() {
      try {
        this.formComponents = await this.$store.dispatch('getFormComponents')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getSurveyForm() {
      try {
        await this.getFormComponents()

        this.surveyForm = await this.$store.dispatch('getSurveyForm', {
          surveyId: this.surveyId,
          surveyFormId: this.surveyFormId,
        })

        this.selectedComponent = this.formComponents.find(
          (fc) => fc.id === this.surveyForm.formComponentId,
        )

        showModal('modalCreateEditSurveyForm')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      try {
        if (this.surveyForm.order === '') {
          throw new Error('Por favor, informe a ordem do campo.')
        }
        if (this.surveyForm.field1 === '') {
          throw new Error('Por favor, informe a pergunta.')
        }

        this.disableButton = true
        let response = null

        if (this.surveyFormId) {
          response = await this.$store.dispatch('updateSurveyForm', {
            surveyId: this.surveyId,
            surveyFormId: this.surveyFormId,
            surveyForm: this.surveyForm,
          })
        } else {
          this.surveyForm.formComponentId = this.selectedComponent.id

          response = await this.$store.dispatch('createSurveyForm', {
            surveyId: this.surveyId,
            surveyForm: this.surveyForm,
          })
        }

        hideModal()
        this.$emit('closeModal', true)
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    if (this.surveyFormId) {
      this.getSurveyForm()
    } else {
      this.getFormComponents()
      showModal('modalCreateEditSurveyForm')
    }
  },
}
</script>
